import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import CircularProgress from '@material-ui/core/CircularProgress';
import green from '@material-ui/core/colors/green';
import Button from '@material-ui/core/Button';
import CheckIcon from '@material-ui/icons/Check';
import SettingsRemote from '@material-ui/icons/SettingsRemote';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'fixed',
    right: theme.spacing.unit * 4,
    bottom: theme.spacing.unit * 6
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

export const WebcamButton = ({ classes, scanned, enabled, onClick }) => {
  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <Button
          variant="fab"
          color="primary"
          className={scanned ? classes.buttonSuccess : ""}
          onClick={onClick}
        >
          {scanned ? <CheckIcon /> : <SettingsRemote />}
        </Button>
        {(enabled && !scanned) && <CircularProgress size={68} className={classes.fabProgress} />}
      </div>
    </div>
  );
}

WebcamButton.propTypes = {
  scanned: PropTypes.bool.isRequired,
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(WebcamButton);


// WEBPACK FOOTER //
// ./src/components/webcam-button.js